import usps from "../assets/usps.svg";
import { useState } from "react";

const parseUspsDate = (value) => {
  if (!value || typeof value !== "string") {
    return null;
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [year, month, day] = value.split("-").map(Number);
    return new Date(year, month - 1, day);
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const ShippingBoxUSPS = (props) => {
  const [min, setMin] = useState(100);
  const [max, setMax] = useState(0);

  const weather = props.weather;

  let service= props.service;

  if (props.service === "First-Class Mail" || props.service === "Ground Advantage"){
    service = "Ground Advantage"
  }

  const checkWeather = () => {
    const deliveryDate = parseUspsDate(props.expectedDelivery);
    if (!deliveryDate) {
      return;
    }

    const today = new Date();

    const daysBetween = Math.ceil((deliveryDate - today) / 86400000);

    weather.map((day, i) => {
      if (i < daysBetween + 1) {
        if (day.temp.min < min) {
          setMin(day.temp.min);
        }
        if (day.temp.max > max) {
          setMax(day.temp.max);
        }
      }
    });
  };

  checkWeather();

  return (
    <div className="w-full max-w-sm rounded-xl bg-neutral-50 p-6 shadow-sm">
      <div className="flex content-center justify-center pb-3">
        <img src={usps} alt="ups logo" className="h-8 w-10 m-3" />
        <h1 className="m-auto text-xl font-bold text-slate-700">
          {service}
        </h1>
      </div>
      <h3 className="text-lg text-slate-700">
        Expected Delivery: {props.expectedDelivery}
      </h3>
      {min < props.low && (
        <h4 className="text-xl font-semibold text-red-800">Do Not Ship</h4>
      )}
      {min > props.high && (
        <h4 className="text-xl font-semibold text-green-500">Safe To Ship</h4>
      )}
      {/* {min < props.low -3 && min > props.low + 3 && (
        <h4 className="text-xl font-semibold text-green-500">Marginal</h4>
      )} */}

      {min < props.high && min > props.low && (
        <h4 className="text-xl font-semibold text-red-500">
          Insulation Needed
        </h4>
      )}
      <h5 className="text-md italic  text-slate-700">
        Low: {props.tempUnit ? <span>{min} °F</span> :<span>{Math.round((min - 32) * 5/9)} °C</span>} High: {props.tempUnit ? <span>{max} °F</span> :<span>{Math.round((max - 32) * 5/9)} °C</span>}
      </h5>
    </div>
  );
};

export default ShippingBoxUSPS;
